import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import MediaQuery from 'react-responsive'
import Sticky from 'react-stickynode'
import classNames from 'classnames'
import { amplitudeSendEvent } from 'cityads-v3/utils/counterUtils'
import { withTranslation } from 'react-i18next'
import i18n from 'cityads-v3/i18n'
import withHooks from 'cityads-v3/decorators/withHooks'
import { OfferFiltersContext, OfferTabValue } from './OfferFilters.hooks'

import {
  getActionTypeDirections,
  getConnectRequests,
  getCategories,
  getOfferStat,
  getOfferTags,
  getRegions,
  getTools,
  getFavorites,
} from 'cityads-v3/actions/offers'

import {
  getWmOfferSubscription
} from 'cityads-v3/actions/wmOfferSubscription'

import {
  getSubscriptionStatuses
} from 'cityads-v3/actions/subscriptionStatuses'

import BackToSchoolBanner from './Banners/BackToSchoolBanner/BackToSchoolBanner'
import BeautyBanner from './Banners/BeautyBanner/BeautyBanner'
import BlackFridayBanner from './Banners/BlackFridayBanner/BlackFridayBanner'
import CyberMondayBanner from './Banners/CyberMondayBanner/CyberMondayBanner'
import February23Banner from './Banners/February23Banner/February23Banner'
import JuneBanner from './Banners/JuneBanner/JuneBanner'
import March8Banner from './Banners/March8Banner/March8Banner'
import MayHolidaysBanner from './Banners/MayHolidaysBanner/MayHolidaysBanner'
import MayQuestBanner from './Banners/MayQuestBanner/MayQuestBanner'
import NewYearBanner from './Banners/NewYearBanner/NewYearBanner'
import OktoberfestBanner from './Banners/OktoberfestBanner/OktoberfestBanner'
import TravelBanner from './Banners/TravelBanner/TravelBanner'
import ValentinesDayBanner from './Banners/ValentinesDayBanner/ValentinesDayBanner'
import GetLinkDialog from './GetLinkDialog'
import SuggestOffer from './SuggestOffer'

import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Collapse from '@mui/material/Collapse'
import Paper from '@mui/material/Paper'
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined'
import Typography from '@mui/material/Typography'

import Balaclava from 'cityads-v3/components/Balaclava'
import EmptyResults from 'cityads-v3/components/EmptyResults'
import ListingPageToolbar from 'cityads-v3/components/ListingPageToolbar/ListingPageToolbar'
import Paginator from 'cityads-v3/components/Paginator/Paginator'
import TemporaryRedirect from 'cityads-v3/components/Router/TemporaryRedirect'
import ViewSelector from 'cityads-v3/components/ViewSelector/ViewSelector'

import {
  USER_ROLE_CODE_WEBMASTER,
} from 'cityads-v3/reducers/auth'

import classes from './Offers.scss'
import OffersSelectedFilters from './OffersSelectedFilters'
import OffersList from './OffersList'
import OfferFilters from './OfferFilters'
import {
  useOffers,
  useExportsConfigOffers,
  useOrderKeys,
  useFavoriteCount,
  useDoubleColumnLimit,
} from './Offers.hooks'

export const PROPERTY_ITEM_SLICE = 3

@withRouter
@withHooks(props => {
  const {
    clearFilters,
    listRef,
    offerFilters,
    offerTags,
    setPage,
    setPageLimit,
    scrollToTop,
    view,
    setView,
    themeChanger,
    totalText,
  } = useOffers(props)

  const [favoriteTotal, favoriteLoad] = useFavoriteCount()
  const doubleColumnLimit = useDoubleColumnLimit()

  return {
    ...props,
    clearFilters,
    doubleColumnLimit,
    favoriteTotal,
    favoriteLoad,
    listRef,
    exportsConfigOffers: useExportsConfigOffers(offerFilters, props.embeddedUrlAdditional),
    offerFilters,
    offerTags,
    orderKeys: useOrderKeys(),
    scrollToTop,
    setPage,
    setPageLimit,
    setView,
    themeChanger,
    totalText,
    view,
  }
})
@connect(
  (state, props) => ({
    offers: state.offers.offers.map(id => state.offers.offersById[id]).filter(offer => !!offer),
    offersGlobalTotal: state.offers.offersGlobalTotal,
    isLoadingOffers: state.offers.isLoadingOffers,
    offerStatByOfferId: state.offers.offerStatByOfferId,
    offerFavoritesStateByOfferId: state.offers.offerFavoritesStateByOfferId,
    filterTotal: state.offers.filterTotal.total,
    language: state.language.language,

    user: state.auth.user,
    userRoleCode: state.auth.user?.user_role_code,
    userId: state.auth.user?.id,
    isAuthChecked: state.auth.isAuthChecked,
    isLoggedIn: state.auth.isLoggedIn,

    isMobile: state.app.isMobile,

    metaTotal: state.offers.meta.total,
    metaLimit: state.offers.meta.limit,
    metaPage: state.offers.meta.page,
    withFilters: state.offers.meta.withFilters,

    isLoadedActionTypeDirections: state.offers.isLoadedActionTypeDirections,
    isLoadedCategories: state.offers.isLoadedCategories,
    isLoadedOfferTags: state.offers.isLoadedOfferTags,
    isLoadedRegions: state.offers.isLoadedRegions,
    isLoadedTools: state.offers.isLoadedTools,
    isLoadedSubscriptionStatuses: state.subscriptionStatuses.isLoaded,
    isStorageCookieOk: state.auth.isStorageCookieOk,
    isStorageCookieChecked: state.auth.isStorageCookieChecked,
  })
)
@withTranslation(['Offers'], { i18n, wait: !!window })
export default class Offers extends Component {

  static propTypes = {
    dispatch: PropTypes.func,
    t: PropTypes.func,
    tabValue: PropTypes.number,
    offers: PropTypes.array,
    offersGlobalTotal: PropTypes.number,
    isLoadingOffers: PropTypes.bool,
    offerStatByOfferId: PropTypes.object,
    offerFavoritesStateByOfferId: PropTypes.object,
    filterTotal: PropTypes.number,
    user: PropTypes.object,
    userRoleCode: PropTypes.string,
    userId: PropTypes.string,
    isAuthChecked: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    language: PropTypes.string,
    isMobile: PropTypes.bool,
    embedded: PropTypes.bool,
    embeddedUrlAdditional: PropTypes.string,
    linkSource: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    showSettingView: PropTypes.bool,
    customActions: PropTypes.array,
    customBody: PropTypes.func,
    customCardTitle: PropTypes.func,
    showActions: PropTypes.bool,
    showTargetsTable: PropTypes.bool,
    displayFilters: PropTypes.object,
    showSelectedFilters: PropTypes.bool,
    customSelectedFilters: PropTypes.element,
    listFooter: PropTypes.element,
    totalText: PropTypes.node,

    metaTotal: PropTypes.number,
    metaLimit: PropTypes.number,
    metaPage: PropTypes.number,
    withFilters: PropTypes.bool,
    view: PropTypes.oneOf(['list', 'table', 'cards']),

    isLoadedActionTypeDirections: PropTypes.bool,
    isLoadedCategories: PropTypes.bool,
    isLoadedRegions: PropTypes.bool,
    isLoadedTools: PropTypes.bool,
    isLoadedSubscriptionStatuses: PropTypes.bool,
    isStorageCookieOk: PropTypes.bool,
    isStorageCookieChecked: PropTypes.bool,

    onOffersLoaded: PropTypes.func,
  }

  static defaultProps = {
    showActions: true,
    showSettingView: true,
    showTargetsTable: true,
    showSelectedFilters: true,
  }

  componentDidMount() {
    const params = { ...this.props }

    if (!params.isLoadedRegions) { params.dispatch(getRegions()) }
    if (!params.isLoadedTools) { params.dispatch(getTools()) }
    if (!params.isLoadedOfferTags) { params.dispatch(getOfferTags()) }

    if (!params.isLoadedActionTypeDirections) { params.dispatch(getActionTypeDirections()) }
    if (!params.isLoadedSubscriptionStatuses && params.isLoggedIn) { params.dispatch(getSubscriptionStatuses()) }

    if (!params.isLoadedCategories) { params.dispatch(getCategories()) }

    if (!params.linkSource) {
      amplitudeSendEvent('makeActions', 'd-v1-e7', 'offers', 'tab_view', { tab_name: 'offers' })
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const oldProps = this.props
    const { dispatch } = newProps
    const offersIds = newProps.offers.map(item => item.id)

    if (!newProps.isLoadingOffers && newProps.userId && (oldProps.isLoadingOffers || !oldProps.userId)) {
      const ids = offersIds.filter(id => !newProps.offerFavoritesStateByOfferId[id])

      if (ids.length) {
        dispatch(getFavorites(ids))
      }
    }

    if (offersIds.length) {
      if (oldProps.isLoadingOffers && !newProps.isLoadingOffers) {
        newProps.onOffersLoaded?.(offersIds)
        dispatch(getOfferStat(offersIds))
      }

      if (!newProps.isLoadingOffers && newProps.userId && newProps.userRoleCode === USER_ROLE_CODE_WEBMASTER && (oldProps.isLoadingOffers || !oldProps.userId)) {
        dispatch(getConnectRequests(offersIds))
        dispatch(getWmOfferSubscription(offersIds, newProps.userId))
      }
    }


    if (newProps.language && oldProps.language !== newProps.language) {
      setTimeout(() => {
        newProps.offerFilters.refresh();

        dispatch(getCategories())
        dispatch(getRegions())
        dispatch(getTools())
        dispatch(getOfferTags())
        dispatch(getActionTypeDirections())

        if (newProps.isLoggedIn) {
          dispatch(getSubscriptionStatuses())
        }
      }, 10)
    }
  }

  render() {
    const {
      t,
      location,
      embedded,
      linkSource,
      tabValue,
      isAuthChecked,
      isLoggedIn,
      listFooter,
      defaultFilters,
      displayFilters,
      scrollToTop,
      offerFilters,
      view,
      setView,
      forceView,
      exportsConfigOffers,
      orderKeys,
      totalText,
    } = this.props
    const isFavoritesPage = tabValue === OfferTabValue.FILTER_TYPE_FAVORITES
    const isLoading = this.props.isLoadingOffers

    if (isFavoritesPage && isAuthChecked && !isLoggedIn) {
      return (
        <TemporaryRedirect to={{
          ...location,
          pathname: '/publisher/offers',
        }} />
      )
    }

    const data = this.props.offers.map(item => {
      return {
        ...item,
        ...this.props.offerStatByOfferId[item.id],
      }
    })

    const notFound = data.length === 0 && isLoading === false ? (
      <EmptyResults
        icon={<FilterListOutlinedIcon />}
        emptyText={isFavoritesPage ? t('emptyFavorites') : t('emptyResults')}
        actions={<Button onClick={() => { offerFilters.clearFilters() }}>{t('resetFilters')}</Button>}
      />
    ) : false

    const toolbar = (
      <ListingPageToolbar
        orderKeys={orderKeys}
        selectedSort={offerFilters.selectedFilters.fields.order.value}
        onChangeSort={offerFilters.handleChangeOrder.bind(this)}
        viewComponent={this.props.showSettingView ? (
          <ViewSelector
            onChange={setView}
            variants={['cards', 'list', 'table']}
            value={forceView ?? view}
          />
        ) : undefined}
        totalText={totalText}
        exports={embedded ? null : exportsConfigOffers}
        suggestOffer={embedded ? null : <SuggestOffer />}
      />
    )
    return (
      <OfferFiltersContext.Provider value={offerFilters}>
        <div className={classes.offers} id="offersContent">
          {embedded ?
            null :
            (
              <>
                <Helmet
                  title={this.props.title || t('offersList')}
                  meta={[
                    { name: 'description', content: t('description') },
                    { name: 'keywords', content: t('keywords') },
                  ]}
                  link={[
                    {
                      rel: 'canonical',
                      href: window
                        ? `${window.location.origin}${window.location.pathname}`
                        : `https://cityads.com${location.pathname}`
                    }
                  ]}
                />

                <Balaclava
                  title={t('main:header.offers')}
                  menuShow={isLoggedIn}
                  menuValue={isLoggedIn ? tabValue : false}
                  menu={isLoggedIn ? [
                    {
                      id: OfferTabValue.FILTER_TYPE_ALL,
                      title: t('Offers:offersAll'),
                      route: '/publisher/offers',
                      total: this.props.offersGlobalTotal,
                    },
                    {
                      id: OfferTabValue.FILTER_TYPE_FAVORITES,
                      title: t('Offers:offersFavorite'),
                      route: '/publisher/offers/favorites',
                      total: this.props.favoriteTotal,
                    }
                  ] : []}
                />
              </>
            )
          }

          <MediaQuery minWidth={this.props.doubleColumnLimit}>
            {(isDoubleColumn) => (
              <>
                {isDoubleColumn ? toolbar : null}

                <div className={classes.offersWrapper}>
                  <div className={classes.offersSidebar}>
                    <Sticky
                      enabled={isDoubleColumn}
                      top={'#header'}
                      bottomBoundary="#offersContent"
                    >
                      <OfferFilters
                        defaultFilters={defaultFilters}
                        displayFilters={displayFilters}
                      />
                    </Sticky>
                  </div>

                  {isDoubleColumn ?
                    null :
                    (
                      <div className={classes.offersToolbarColumn}>
                        {toolbar}
                      </div>
                    )
                  }

                  <div className={classes.offersMainColumn}>
                    <BackToSchoolBanner />
                    <BeautyBanner />
                    <BlackFridayBanner />
                    <CyberMondayBanner />
                    <February23Banner />
                    <JuneBanner />
                    <March8Banner />
                    <MayHolidaysBanner />
                    <MayQuestBanner />
                    <NewYearBanner />
                    <OktoberfestBanner />
                    <TravelBanner />
                    <ValentinesDayBanner />

                    <OffersSelectedFilters
                      displayFilters={displayFilters}
                      label={this.props.customSelectedFilters ? t('main:filters') : null}
                    />
                    {this.props.customSelectedFilters}

                    <div ref={this.props.listRef}>
                      <Collapse in={isLoading} mountOnEnter unmountOnExit className={classes.offersProgressWrapper}>
                        <CircularProgress size={40} className={classes.offersProgress} />
                      </Collapse>

                      <div className={classNames(classes.offers__list, {
                        [classes.offers__list__away]: isLoading,
                        [classes.offers__list__view_cards]: (forceView ?? view) === 'cards' && !notFound,
                      })}>
                        {data.length && !isLoading ? (
                          <Typography color="textSecondary" className={classes.totalText}>{totalText}</Typography>
                        ) : null}


                        <OffersList
                          offers={data}
                          customActions={this.props.customActions}
                          customBody={this.props.customBody}
                          customCardTitle={this.props.customCardTitle}
                          isFavoritesPage={isFavoritesPage}
                          linkSource={linkSource}
                          reloadFavoriteTotalCount={this.props.favoriteLoad}
                          showActions={this.props.showActions}
                          showTargetsTable={this.props.showTargetsTable}
                          view={forceView ?? view}
                        />

                        {notFound}
                      </div>
                    </div>

                    {data.length ?
                      <Paper>
                        <div className={classNames.paginator}>
                          <Paginator
                            count={Math.ceil(this.props.metaTotal)}
                            page={this.props.metaPage}
                            rowsPerPage={this.props.metaLimit}
                            onPageChange={(evt, page) => {
                              scrollToTop?.()
                              this.props.setPage(page)
                            }}
                            onRowsPerPageChange={pageLimit => this.props.setPageLimit(pageLimit)}
                          />
                        </div>
                      </Paper>
                      :
                      false
                    }

                    {listFooter}

                    <GetLinkDialog />
                  </div>
                </div>
              </>
            )}
          </MediaQuery>
        </div>
      </OfferFiltersContext.Provider>
    )
  }

}
